import { Button } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';
import { PageStateLandmark } from '@/components/layout/main-landmark';

/**
 * What a page shows once a stale bundle has already broken it: the tab is older
 * than the API it is talking to, and a reload is the fix. The reload is offered,
 * never performed — it would destroy whatever the user was typing.
 *
 * The provider-free twin of this state lives in `RootErrorBoundary`, which sits
 * outside `<I18nProvider>` and cannot use this component.
 */
export function OutdatedView() {
  const t = useTranslations('common.outdated-view');
  const explain = useTranslations('errors.app');

  return (
    <PageStateLandmark className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-4 p-8">
      <h2 className="text-2xl font-semibold">{t('title')}</h2>
      <p className="text-text-secondary">{explain('outdated')}</p>
      <Button onClick={() => window.location.reload()}>{t('action')}</Button>
    </PageStateLandmark>
  );
}
